export default __webpack_public_path__ + "static/media/5.b44e5e69.jpg";